import { Fieldset, Heading, Paragraph, Radio, Textfield, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { PanelWrapper } from '../styledComponents';
import { useSolcellerValidation } from '../useSolcellerValidation';
import { useSolcelleFormContext } from '../../utils';

interface Props {
  index: number;
}

export const SolcelletaksteinInput: FC<Props> = ({ index }) => {
  const { t } = useTranslation();
  const { register, watch, formState } = useSolcelleFormContext();

  const { validateArea, decimalPattern } = useSolcellerValidation();
  const sqmPanels = watch('sqmPanels');
  const { errors } = formState;

  const displayPanelAreaInput = (index: number) => sqmPanels?.[index]?.hasActivePanelArea === 'yes';
  const displayRoofAreaInput = (index: number) => sqmPanels?.[index]?.hasActivePanelArea === 'no';

  const activePanelAreaError = errors.sqmPanels?.[index]?.hasActivePanelArea?.message;

  return (
    <PanelWrapper>
      <Heading level={4} data-size="xs">
        {t('register.solar.form.panel.activePanels.header')}
      </Heading>
      <Paragraph>{t('register.solar.form.panel.activePanels.description')}</Paragraph>
      <Fieldset>
        <Fieldset.Legend>{t('register.solar.form.panel.activePanels.label')}</Fieldset.Legend>
        <Radio
          {...register(`sqmPanels.${index}.hasActivePanelArea`, {
            required: t('register.solar.form.panel.activePanels.error')
          })}
          aria-invalid={!!activePanelAreaError}
          label={t('yes')}
          value="yes"
        />
        <Radio
          {...register(`sqmPanels.${index}.hasActivePanelArea`, {
            required: t('register.solar.form.panel.activePanels.error')
          })}
          aria-invalid={!!activePanelAreaError}
          label={t('no')}
          value="no"
        />
        {activePanelAreaError && <ValidationMessage>{activePanelAreaError}</ValidationMessage>}
      </Fieldset>
      {displayPanelAreaInput(index) && (
        <Textfield
          type="text"
          inputMode="decimal"
          label={t('register.solar.form.panel.area')}
          suffix={t('register.solar.form.suffix.sqm')}
          error={errors.sqmPanels?.[index]?.area?.message}
          {...register(`sqmPanels.${index}.area`, {
            pattern: decimalPattern,
            validate: validateArea
          })}
        />
      )}
      {displayRoofAreaInput(index) && (
        <Textfield
          type="text"
          inputMode="decimal"
          label={t('register.solar.form.panel.roofArea')}
          suffix={t('register.solar.form.suffix.sqm')}
          error={errors.sqmPanels?.[index]?.roofArea?.message}
          {...register(`sqmPanels.${index}.roofArea`, {
            pattern: decimalPattern,
            validate: validateArea,
            deps: [`sqmPanels.${index}.area`]
          })}
        />
      )}
    </PanelWrapper>
  );
};
